var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-1"},[_c('ManageCorrespondenceVue')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }